import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "layout-menu",
  role: "menu"
}
const _hoisted_2 = { class: "layout-menuitem-text" }
const _hoisted_3 = {
  key: 0,
  class: "pi pi-fw pi-angle-down layout-submenu-toggler"
}
const _hoisted_4 = ["onClick", "onMouseenter"]
const _hoisted_5 = { class: "layout-menuitem-text" }
const _hoisted_6 = {
  key: 0,
  class: "pi pi-fw pi-angle-down layout-submenu-toggler"
}
const _hoisted_7 = {
  key: 2,
  class: "layout-root-menuitem"
}
const _hoisted_8 = {
  class: "layout-menuitem-root-text",
  style: {"text-transform":"uppercase"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_submenu = _resolveComponent("submenu")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_ctx.items)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (_ctx.hasVisibleChildren(item) || _ctx.isChildVisible(item) || _ctx.hasZeroChildren(item))
              ? (_openBlock(), _createElementBlock("li", {
                  key: item.label || i,
                  class: _normalizeClass([
          {
            'layout-root-menuitem': _ctx.root,
            'active-menuitem': _ctx.activeIndex === i,
          },
        ]),
                  role: "menuitem"
                }, [
                  (item.to !== undefined)
                    ? _withDirectives((_openBlock(), _createBlock(_component_router_link, {
                        key: 0,
                        to: item.to,
                        class: "p-ripple",
                        "active-class": "active-route",
                        exact: "",
                        onClick: ($event: any) => (_ctx.onMenuItemClick($event, item, i)),
                        onMouseenter: ($event: any) => (_ctx.onMenuItemMouseEnter(i))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: _normalizeClass(['layout-menuitem-icon', item.icon])
                          }, null, 2),
                          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.t(`navigation.${item.label}`)), 1),
                          (item.items)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_3))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["to", "onClick", "onMouseenter"])), [
                        [_directive_ripple]
                      ])
                    : _withDirectives((_openBlock(), _createElementBlock("a", {
                        key: 1,
                        href: "#",
                        class: "p-ripple",
                        onClick: ($event: any) => (_ctx.onMenuItemClick($event, item, i)),
                        onMouseenter: ($event: any) => (_ctx.onMenuItemMouseEnter(i))
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(['layout-menuitem-icon', item.icon])
                        }, null, 2),
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.t(`navigation.${item.label}`)), 1),
                        (item.items)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                          : _createCommentVNode("", true)
                      ], 40, _hoisted_4)), [
                        [_directive_ripple]
                      ]),
                  (_ctx.root)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.t(`navigation.${item.label}`)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.hasZeroChildren(item))
                    ? (_openBlock(), _createBlock(_Transition, {
                        key: 3,
                        name: "layout-menu"
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_submenu, {
                            items: item.items,
                            menuActive: _ctx.menuActive,
                            layoutMode: _ctx.layoutMode,
                            parentMenuItemActive: _ctx.activeIndex === i,
                            onMenuitemClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('menuitem-click', $event)))
                          }, null, 8, ["items", "menuActive", "layoutMode", "parentMenuItemActive"]), [
                            [_vShow, item.items && (_ctx.root && (!_ctx.isSlim() || (_ctx.isSlim() && (_ctx.mobileMenuActive || _ctx.activeIndex !== undefined))) ? true : _ctx.activeIndex === i)]
                          ])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ], 2))
              : _createCommentVNode("", true),
            ((!_ctx.isLastItem(i) && _ctx.hasVisibleChildren(item)) || _ctx.hasZeroChildren(item))
              ? (_openBlock(), _createElementBlock("li", {
                  class: "menu-separator",
                  key: 'separator' + i,
                  role: "separator"
                }))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]))
    : _createCommentVNode("", true)
}